import { Context } from '@nuxt/types'

import { authModule } from '@/store'
import { anonymousRoutes } from '@/utils/auth'

export default async function ({ $axios, redirect, route, store }: Context) {
  // change old routes to new routes
  if (route.path === '/login') {
    return redirect('/sign-in')
  } else if (route.path === '/register') {
    return redirect('/sign-up')
  }

  if (authModule.loggedIn && !authModule.isLoaded) {
    await authModule.fetchUser()
  }

  // Match anonymous routes case-insensitively and on segment boundaries.
  // vue-router matches paths case-insensitively, so a case-sensitive
  // `startsWith` could diverge from the route that actually renders, and a
  // loose prefix would treat e.g. `/get-started-evil` as anonymous. Same
  // vulnerability class as GHSA-mm7m-92g8-7m47 (Nuxt 3/4 routeRules
  // case-mismatch); the API token remains the real authorization boundary.
  const normalizedPath = route.path.toLowerCase()
  const canAccessAnonymously = anonymousRoutes.some((path) => {
    const allowed = path.toLowerCase()
    return (
      normalizedPath === allowed || normalizedPath.startsWith(`${allowed}/`)
    )
  })

  if (!authModule.loggedIn) {
    if (canAccessAnonymously) {
      // This section of the web app can be accessed anonymously. Create a new
      // anonymous user and update our auth state
      const { data } = await $axios.post('/api/users/create-anonymous')

      $axios.setToken(data.token, 'Bearer')
      store.dispatch('auth/setTokens', {
        accessToken: data.token,
      })
      store.dispatch('auth/setUser', data.user)

      return
    }

    // Redirect to sign-in page if the user is not authenticated
    return route.path === '/'
      ? redirect('/sign-in')
      : redirect('/sign-in', { redirectTo: route.fullPath })
  } else if (
    authModule.user.accountType === 'anonymous' &&
    !canAccessAnonymously
  ) {
    // We currently restrict access for anonymous users to the AI onboarding.
    // Redirect to the AI onboarding home page if an anonymous users tries to
    // access anything else.
    redirect('/get-started')
  }
}
